import { defineComponent as H, openBlock as t, createElementBlock as o, mergeProps as p, unref as a, renderSlot as u, createElementVNode as e, createCommentVNode as h } from "vue";
import { useScalarIcon as i } from "../hooks/useScalarIcon.js";
const m = { key: 0 }, L = { key: 1 }, g = { key: 2 }, f = { key: 3 }, Z = { key: 4 }, k = { key: 5 }, w = {
  name: "ScalarIconPulse"
}, _ = /* @__PURE__ */ H({
  ...w,
  props: {
    label: {},
    weight: {}
  },
  setup(s) {
    const r = s, { bind: d, weight: n } = i(r);
    return (A, l) => (t(), o("svg", p({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      fill: "currentColor"
    }, a(d)), [
      u(A.$slots, "default"),
      a(n) === "bold" ? (t(), o("g", m, l[0] || (l[0] = [
        e("path", { d: "M244,128a12,12,0,0,1-12,12H207.42l-36.69,73.37A12,12,0,0,1,160,220h-.6a12,12,0,0,1-10.61-7.72L95,71.15,66.92,133A12,12,0,0,1,56,140H24a12,12,0,0,1,0-24H48.27L85.08,35a12,12,0,0,1,22.13.7l54.28,142.46,27.78-55.56A12,12,0,0,1,200,116h32A12,12,0,0,1,244,128Z" }, null, -1)
      ]))) : a(n) === "duotone" ? (t(), o("g", L, l[1] || (l[1] = [
        e("path", {
          d: "M96,40l33.52,88H56Zm104,88H129.52L160,208Z",
          opacity: "0.2"
        }, null, -1),
        e("path", { d: "M240,128a8,8,0,0,1-8,8H204.94l-37.78,75.58A8,8,0,0,1,160,216h-.4a8,8,0,0,1-7.08-5.14L95.35,60.76,63.28,131.31A8,8,0,0,1,56,136H24a8,8,0,0,1,0-16H50.85L88.72,36.69a8,8,0,0,1,14.76.46l57.51,151,31.85-63.71A8,8,0,0,1,200,120h32A8,8,0,0,1,240,128Z" }, null, -1)
      ]))) : a(n) === "fill" ? (t(), o("g", g, l[2] || (l[2] = [
        e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-8,96H188.64L159,188a8,8,0,0,1-6.95,4h-.46a8,8,0,0,1-6.89-4.84L103,89.92,79,132a8,8,0,0,1-7,4H48a8,8,0,0,1,0-16H67.36L97.05,68a8,8,0,0,1,14.3.82L153,166.08l24-42.05a8,8,0,0,1,6.95-4h24a8,8,0,0,1,0,16Z" }, null, -1)
      ]))) : a(n) === "light" ? (t(), o("g", f, l[3] || (l[3] = [
        e("path", { d: "M238,128a6,6,0,0,1-6,6H203.71l-38.34,76.68A6,6,0,0,1,160,214h-.3a6,6,0,0,1-5.31-3.85L95.51,55.57,61.46,130.48A6,6,0,0,1,56,134H24a6,6,0,0,1,0-12H52.14l38.4-84.48a6,6,0,0,1,11.07.34L160.74,193.1l33.89-67.78A6,6,0,0,1,200,122h32A6,6,0,0,1,238,128Z" }, null, -1)
      ]))) : a(n) === "regular" ? (t(), o("g", Z, l[4] || (l[4] = [
        e("path", { d: "M240,128a8,8,0,0,1-8,8H204.94l-37.78,75.58A8,8,0,0,1,160,216h-.4a8,8,0,0,1-7.08-5.14L95.35,60.76,63.28,131.31A8,8,0,0,1,56,136H24a8,8,0,0,1,0-16H50.85L88.72,36.69a8,8,0,0,1,14.76.46l57.51,151,31.85-63.71A8,8,0,0,1,200,120h32A8,8,0,0,1,240,128Z" }, null, -1)
      ]))) : a(n) === "thin" ? (t(), o("g", k, l[5] || (l[5] = [
        e("path", { d: "M236,128a4,4,0,0,1-4,4H202.47l-38.89,77.79A4,4,0,0,1,160,212h-.2a4,4,0,0,1-3.54-2.58l-60.59-159-36,79.28A4,4,0,0,1,56,132H24a4,4,0,0,1,0-8H53.42L92.36,38.35a4,4,0,0,1,7.38.23L160.5,198.06l35.92-71.85A4,4,0,0,1,200,124h32A4,4,0,0,1,236,128Z" }, null, -1)
      ]))) : h("", !0)
    ], 16));
  }
});
export {
  _ as default
};
